// @flow

import { createSelectorCreator, defaultMemoize } from 'reselect';

import equals from 'ramda/src/equals';
import eqProps from 'ramda/src/eqProps';

export const createDeepEqualSelector = createSelectorCreator(
  defaultMemoize,
  equals
);

export const createPropertyEqualSelector = (key: string) => {
  return createSelectorCreator(defaultMemoize, eqProps(key));
};



// WEBPACK FOOTER //
// ./js/util/selectors.js